var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBell = function SvgBell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5,19H21v-1.5c0-0.3-0.2-0.5-0.5-0.5h-17C3.2,17,3,17.2,3,17.5V19H1.5C1.2,19,1,19.2,1,19.5v1 C1,20.8,1.2,21,1.5,21h21c0.3,0,0.5-0.2,0.5-0.5v-1C23,19.2,22.8,19,22.5,19z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,14H20c0-4.1-3.1-7.4-7-7.9V5h0.5C13.8,5,14,4.8,14,4.5v-1C14,3.2,13.8,3,13.5,3h-3C10.2,3,10,3.2,10,3.5 v1C10,4.8,10.2,5,10.5,5H11v1.1C7.1,6.6,4,9.9,4,14H3.5C3.2,14,3,14.2,3,14.5v1C3,15.8,3.2,16,3.5,16h17c0.3,0,0.5-0.2,0.5-0.5v-1 C21,14.2,20.8,14,20.5,14z M6,14H5c0-3.9,3.1-7,7-7c0.1,0,0.2,0,0.3,0C8.8,7.2,6,10.2,6,14z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bell.7e8734b4.svg";
export { ForwardRef as ReactComponent };